import * as React from 'react';
import WelcomePageHighlightBlock from '../../api/welcomePageHighlightBlockEntity';

interface IProps {
    mainHighlightItems: WelcomePageHighlightBlock[];
    subMainHighlightItems: WelcomePageHighlightBlock[];
    fetchWelcomePageHighlightMainItems(): void;
    fetchWelcomePageHighlightSubMainItems(): void;
}

export class WelcomePageMainHighlight extends React.Component<IProps,{}> {
  public componentDidMount() {
    this.props.fetchWelcomePageHighlightMainItems();
    this.props.fetchWelcomePageHighlightSubMainItems();
  }

  public render() {
    return (
        <React.Fragment>
            <div className="row main-row">
                {this.props.mainHighlightItems.map(WelcomePageMainHighlightItem)}
            </div>
            
            <div className="row">
                {this.props.subMainHighlightItems.map(WelcomePageMainSubHighlightItem)}
            </div>
      </React.Fragment>
    );
  }
};

const WelcomePageMainHighlightItem = (topNavigationMenuItem: WelcomePageHighlightBlock) => {
  const divClassName = topNavigationMenuItem.additionalHighlightBoxCssClass === "" ? "box news" : topNavigationMenuItem.additionalHighlightBoxCssClass;

  return (
    <div className="col-md-4">
        <div className={divClassName}>
            <a href={topNavigationMenuItem.highlightUrl} target={topNavigationMenuItem.highlightUrlTarget} className="box-inner-wrap" tabIndex={-1} title={topNavigationMenuItem.highlightUrlText}>
                <div className="box-image-wrap"><img alt="" src={topNavigationMenuItem.highlightImage} /></div>
                <div className="box-content">
                    <h3>{topNavigationMenuItem.highlightTitle}</h3>
                    <p>{topNavigationMenuItem.highlightBody}</p>
                    <span className="readmore">{topNavigationMenuItem.highlightUrlText}</span>
                </div>
            </a>
        </div>
    </div>
  )
}

const WelcomePageMainSubHighlightItem = (topNavigationMenuItem: WelcomePageHighlightBlock) => {
    const divClassName = topNavigationMenuItem.additionalHighlightBoxCssClass === "" ? "box news" : topNavigationMenuItem.additionalHighlightBoxCssClass;
  
    return (
        <div className="col-md-6">
            <div className={divClassName}>
                <a href={topNavigationMenuItem.highlightUrl} target={topNavigationMenuItem.highlightUrlTarget} className="box-inner-wrap" tabIndex={-1} title={topNavigationMenuItem.highlightUrlText}>
                    <div className="box-content">
                        <h3>{topNavigationMenuItem.highlightTitle}</h3>
                        <p>{topNavigationMenuItem.highlightBody}</p>
                        <span className="readmore">{topNavigationMenuItem.highlightUrlText}</span>
                    </div>
                </a>
            </div>
        </div>
    )
  }


// WEBPACK FOOTER //
// ./src/components/welcomePageHighlight/welcomePageHighlight.tsx